import slugify from "slugify";
import { BlogTocItem } from "./types";

export const parseBlogContentWithAnchors = (
    html: string
): { htmlWithAnchors: string; toc: BlogTocItem[] } => {
    const createDocument = (markup: string): Document => {
        if (typeof window === "undefined") {
            const { JSDOM } = require("jsdom");
            return new JSDOM(markup).window.document;
        }
        return new DOMParser().parseFromString(markup, "text/html");
    };

    const doc = createDocument(html);
    const used = new Set<string>();
    const toc: BlogTocItem[] = [];

    (Array.from(doc.querySelectorAll("h2, h3, h4")) as HTMLElement[]).forEach((h) => {
        const raw = (h.textContent || "").trim();

        let slug = slugify(raw, {
            lower: true,
            strict: true,
            trim: true
        });

        const base = slug;
        let n = 1;
        while (used.has(slug)) slug = `${base}-${n++}`;
        used.add(slug);

        h.id = slug;
        const level = Number(h.tagName.slice(1)) as 2 | 3 | 4;

        toc.push({
            id: slug,
            text: raw,
            level
        });
    });

    return {
        htmlWithAnchors: doc.body.innerHTML,
        toc
    };
};